import styled from '@emotion/styled'

export const DeleteProductUnitTitle = styled.span`
  overflow-wrap: anywhere;
`
